import React, { useState, useContext, forwardRef } from "react";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core/styles";
import MenuIcon from "@material-ui/icons/Menu";
import Box from "@material-ui/core/Box";
import DefaultLogo from "../../../../../assets/images/defaultLogo.png";
import MobileNavDrawer from "./mobileNavbar";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { thumborImageUrl, WebContext } from "../../../../../Utility";
import { StyledMenu } from "./commons";
import useStyles from "./navbarWebStyles";
import LoginButton from "../../../Login/loginButton";
const LoginDropDownType = ({ items = {}, handleLogoutClick = () => {} ,theme}) => {
      const classes = useStyles();
  const { label = "", link = "", id = "" } = items;
  if (id === "logout") {
    return (
      <MenuItem
        onClick={
          typeof handleLogoutClick === "function"
            ? handleLogoutClick
            : undefined
        }
        className={classes.primarytext}
        style={{color:theme?.agentTheme?.background?.primary_text}}
      >
        {(label || "").toUpperCase()}
      </MenuItem>
    );
  } else if (link) {
    return (
      <MenuItem component={"a"} href={link} style={{color:theme?.agentTheme?.background?.primary_text}} className={classes.primarytext}>
        {(label || "").toUpperCase()}
      </MenuItem>
    );
  } else {
    return <MenuItem style={{color:theme?.agentTheme?.background?.primary_text}} className={classes.primarytext}>{(label || "").toUpperCase()}</MenuItem>;
  }
};

const Navbar = forwardRef(
  (
    {
      nonTransparentNav = false,
      logo_url,
      isMobile = false,
      contentArr = [],
      username = "",
      memberProfile = {},
      widgetList = [],
      handleLogoutClick = () => {},
      loginItem = [],
    },
    ref
  ) => {
    const theme = useTheme();
    const [showMenuDrawer, setShowMenuDrawer] = useState(false);
    const [showLogin, setShowLogin] = useState(false);

    const [userAnchorEl, setUserAnchorEl] = useState(null);
    const [navAnchorEl, setNavAnchorEl] = useState(null);
    const handleNavMenuClick = (event) => {
      setNavAnchorEl(event.currentTarget);
    };
    const handleNavMenuClose = () => {
      setNavAnchorEl(null);
    };

    const handleUserMenuClick = (event) => {
      setUserAnchorEl(event.currentTarget);
    };
    const handleUserMenuClose = () => {
      setUserAnchorEl(null);
    };

    const classes = useStyles();

    const { isLoggedIn = false } = useContext(WebContext);

    if (isMobile) {
      return (
        <Box
          ref={ref}
          display="flex"
          justifyContent={"space-between"}
          alignItems="center"
          style={{
            padding: "20px 14px",
            ...(nonTransparentNav ? {} : { backgroundColor: "transparent" }),
          }}
          position={!nonTransparentNav ? "absolute" : "relative"}
          top={!nonTransparentNav && 0}
          zIndex={100}
          width={"100%"}
        >
          <MenuIcon
            style={{
              color: theme.agentTheme.card.link_foreground,
              zIndex: "1",
            }}
            onClick={() => setShowMenuDrawer(true)}
          />
          <MobileNavDrawer
            websiteData={{ memberProfile }}
            showDrawer={showMenuDrawer}
            setShowDrawer={setShowMenuDrawer}
            contentArr={contentArr}
            handleLogoutClick={handleLogoutClick}
            username={username}
            widgetList={widgetList}
          />
          <Box ml={2}>
            <img
              src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
              className={classes.menuLogo}
              onClick={() => {
                window.location.href = `/${username ? `${username}` : ""}`;
              }}
            />
          </Box>

          <Box
            onClick={(e) => {
              e.stopPropagation();
              if (isLoggedIn) {
                handleUserMenuClick(e);
              }
            }}
          >
            <LoginButton loginClass={classes.loginButton} />
          </Box>

          {showLogin &&
            widgetList.find((w) => w.id === "loginModal")?.component &&
            React.createElement(
              widgetList.find((w) => w.id === "loginModal").component,
              { onClose: () => setShowLogin(false) }
            )}
        </Box>
      );
    }

    return (
      <div
        ref={ref}
        className={nonTransparentNav ? classes.solidNavbar : classes.navbar}
      >
        <Box display="flex" justifyContent="space-around" width="100%">
          <Box marginRight="39px" height="70px" width="auto">
            <img
              className={classes.logoImg}
              src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
              onClick={() => {
                window.location.href = `/${username ? `${username}` : ""}`;
              }}
            />
          </Box>
          <Box display="flex">
            {contentArr
              .filter((item) => item.isShow)
              .map((item, idx) => {
                if (
                  item.dropdown &&
                  item.clickItem &&
                  item.clickItem.length > 0
                ) {
                  return (
                    <Box
                      key={`dropdown-${idx}`}
                      display="flex"
                      alignItems="center"
                      className={classes.dropdownWrapper}
                    >
                      <Typography
                        className={classes.contentText}
                        onClick={handleNavMenuClick}
                        style={{ cursor: "pointer" }}
                      >
                        <Box display="flex" alignItems="center">
                          {item.label.toUpperCase()} <ExpandMoreIcon />
                        </Box>
                      </Typography>
                      <StyledMenu
                        anchorEl={navAnchorEl}
                        keepMounted
                        open={Boolean(navAnchorEl)}
                        onClose={handleNavMenuClose}
                        className={classes.dropdownContainer}
                      >
                        {item.clickItem.map((sub, sidx) => (
                          <LoginDropDownType
                            key={`sub-${sidx}`}
                            items={
                              typeof sub.link === "object"
                                ? { ...sub, link: sub.link.pathname }
                                : sub
                            }
                            handleLogoutClick={handleLogoutClick}
                            theme={theme}
                          />
                        ))}
                      </StyledMenu>
                    </Box>
                  );
                }
                return (
                  <Box key={`menu-${idx}`} display="flex" alignItems="center">
                    <a
                      href={
                        typeof item.link === "string"
                          ? item.link
                          : item.link?.pathname
                      }
                      className={classes.contentText}
                    >
                      {item.label.toUpperCase()}
                    </a>
                  </Box>
                );
              })}
          </Box>
          <Box display="flex" alignItems="center" className={classes.loginBtn}>
            <Box
              onClick={(e) => {
                e.stopPropagation();
                if (isLoggedIn) {
                  handleUserMenuClick(e);
                }
              }}
            >
              <LoginButton loginClass={classes.loginButton} />
            </Box>

            <StyledMenu
              anchorEl={userAnchorEl}
              keepMounted
              open={Boolean(userAnchorEl)}
              onClose={handleUserMenuClose}
              className={classes.dropdownContainer}
            >
              {loginItem.map((sub, idx) => (
                <LoginDropDownType
                  key={`user-sub-${idx}`}
                  items={sub}
                  handleLogoutClick={handleLogoutClick}
                />
              ))}
            </StyledMenu>
          </Box>
        </Box>
      </div>
    );
  }
);

export default React.memo(Navbar);
